import React, { Component } from 'react';
import { Link, Navigate, useNavigate } from "react-router-dom";
import API from "../../config/api";
import moment from 'moment';
import CustomModal from "../Bar/CustomModal";
import Pagination from '../Bar/Pagination';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { eventWrapper } from '@testing-library/user-event/dist/utils';

export class CategoryEdit extends React.Component {

    constructor(props) {
        super(props)
      
        this.state = {
          data: null,
          page: 1,
          category_id: 1,
          categories: [],
          percentage: 0,
          disable: true,
          thumbnail: "",
          image_url: "",
          all_categories: [],
          total: 0,
          limit: 10,
          success: null,
          s: '',
          limit: null,
          fields: {
            name: "",
            // correct_answer: ""
          },
          errors: {},
        }
        this.inputRefs = {
          name: React.createRef(),
          // correct_answer: React.createRef(),
        };
      }

      UNSAFE_componentWillMount() {
        this.getParam("id")
        this.getOneCategory();
        this.getAllCategories();
        this.getQuestionByCategory();
        this.getImage();
      }

      getParam(name) {
        let id = window.location.search.split(`${name}=`)[1]
        this.state.category_id = id;
        this.setState({})
      }

      getImage() {
        let url = API.getImage();
        this.setState({image_url : url})
      }

      getAllCategories = async () => {
        try {
          let query = `page=${this.state.page}`
          let results = await API.getAllCategory(query);
          let data = results.data;
          
          this.setState({ all_categories : data.category });
    
        } catch (error) {
          console.log(error)
        }
      }
    
      getOneCategory = async () => {
        try {
          let query = `category_id=${this.state.category_id}`
          let results = await API.getOneCategory(query);
    
          let data = results.data;
          this.setState({ 
            categories : data, 
            thumbnail: data.thumbnail_url
          });
    
        } catch (error) {
          console.log(error)
        }
      }

      onSearch = async (event) => {
        // cateogory_id=1 , s=code,limit=100
        event.preventDefault();
        let value = event.target.value;
        this.state.s = event.target.value;
        try {
          let query = `s=${value}&category_id=${this.state.category_id}&page=${this.state.page}`
          let results = await API.getAllQuestions(query);
          
          let data = results.data.result;
    
          this.setState({ questions : data.quiz, total: data.total, limit: data.limit });
    
        } catch (error) {
          console.log(error)
        }
      }

      async updateTestAvailable(data) {
        await API.updateTestQuestion({
          id: data.id,
          test_available: data.test_available
        }) ;
        this.getQuestionByCategory();
        toast.success("Your action is successful")
        
      }

      getQuestionByCategory = async () => {
        try {
          let query = "";

          if (this.state.category_id) {
            query = `category_id=${this.state.category_id}&page=${this.state.page}&s=${this.state.s}`
          }
          let results = await API.getAllQuestions(query);
          let data = results.data.result;

          this.setState({questions: data.quiz, total: data.total, limit: data.limit });
    
        } catch (error) {
          console.log(error)
        }
      }

      onPaginationPress = (page) => {
        this.state.page = page;
        this.getQuestionByCategory();
        this.setState({});
      }

      onUploadProgress = (percentage) => {
        this.setState({ percentage: percentage})
        if (percentage ===100) {
          this.setState({ disable: false })
        }
      }

      onChangeFile = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        let name = event.target.name;
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            this.onUploadProgress
          );
          
          if (results){
            this.setState({ categories: {
              ...this.state.categories,
              [name]: results.filename,
            }})
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      handelInput = (event) => {

        const { name, value } = event.target;
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            [name]: value,
          },
          errors: {
            ...prevState.errors,
            [name]: "", // Clear error for the field being updated
          },
        }));
      }
      // handelInput = (event) => {
      //   event.preventDefault();
      //   let value = event.target.value;
      //   let name = event.target.name;
        
      //   this.setState({ categories: {
      //     ...this.state.categories,
      //     [name]: value
      //   }})
      // }

      validateFields = () => {
        const { fields } = this.state;
        const errors = {};
        let firstEmptyField = null;
    
        // Check for empty fields
        Object.keys(fields).forEach((field) => {
          const value = fields[field];
          if (typeof value !== "string" || !value.trim()) {
            errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
      
            // Record the first empty field for focus
            if (!firstEmptyField) {
              firstEmptyField = field;
            }
          }
          // if (!fields[field].trim()) {
          //   errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
          //   if (!firstEmptyField) {
          //     firstEmptyField = field; 
          //   }
          // }
        });
    
        this.setState({ errors });
    
        // Focus on the first empty field
        if (firstEmptyField) {
          this.inputRefs[firstEmptyField].current.focus();
        }
    
        // Return true if no errors
        return Object.keys(errors).length === 0;
      }
    
      handleSubmit = async (event) => {
        event.preventDefault();
        
        try {
          let results = await API.postOneCategory(
            this.state.categories
          );
          if (results.result === 1){
            
            this.setState({ success: results.result })
          }
    
        } catch (error) {
          console.log(error)
        }
      }
      
      deleteQuiz = async (event) => {
        event.preventDefault();
        let data = {
          quiz_id : this.state.data.id
        }
        try {
          let results = await API.postDeleteQuestion(data);
          
          if (results.result){
            toast.success("Your action is successful", {
              data: {
                title: "Success toast",
                text: "This is a success message",
              },
            })
            this.getQuestionByCategory();
          }
    
        } catch (error) {
          console.log(error)
        }
      }
      goBack = () => {
        this.props.navigate(-1); // Navigate to the previous page
      };

  render() {
    return (
        <div className="col-12">
          <ToastContainer />
          {this.state.success && (
              <Navigate to="/categoryindex?success=true" replace={true} />
          )}
            <form className="card" onSubmit={this.handleSubmit}>
                <h4 className="card-title"><strong>Category</strong></h4>

                <div className="card-body row">

                    <div className="col-md-6">
                    <div className="form-group">
                        <label className="require" for="input-required">Name</label>
                        <input type="text" className="form-control" id="input-required" value={this.state.categories.name} name='name' onChange={this.handelInput} />
                    </div>
                    {/* <div className="form-group">  
                        <label for="inputState" className="col-form-label">Parent</label>
                        <select id="inputState" className="form-control">
                        <option>Short Film</option>
                        <option>Funny</option>
                        <option>Love story</option>
                        <option>Sad story</option>
                        </select>
                    </div> */}
                    
                    </div>


                    <div className="col-md-6">
                      {/* <div className="form-group">
                          <label>Score</label>
                          <input className="form-control" type="text" value={this.state.categories.score} name='score' onChange={this.handelInput} />
                      </div> */}
                    </div>
                    {/* <div className="col-md-6">
                      <div className="form-group">
                          <label>Thumbnail</label>
                          {this.state.thumbnail && <img className='h-300px w-fullscreen' src={this.state.thumbnail} alt="..." />}
                          <br /><br />
                          <input type="file" data-provide="dropify" name='thumbnail_url' onChange={this.onChangeFile} />
                          <div class="progress">
                            < div class="progress-bar" role="progressbar" style={{width: this.state.percentage + "%", height: '10px'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"><strong>{this.state.percentage + "%"}</strong></div>
                          </div>
                      </div>
                    </div> */}
                </div>

                

                <h4 className="card-title"><strong>Total questions: <b className="text-success fw-500 w-80px"> {this.state.total.toLocaleString('en-US')}</b></strong></h4>


                <div className="card-body">
                  <div className="flexbox mb-20">      
                    <div className="lookup">
                      <input className="w-250px" type="text" name="s" placeholder="Search" onChange={this.onSearch}  />
                    </div>
                  </div> 
                </div>          

                <table className="table table-hover table-has-action">
                  <thead>
                    <tr>
                      <th>#</th>
                      {/* <th>Thumbnail</th> */}
                      <th>Test</th>
                      <th>Name</th>
                      <th>Question</th>
                      {/* <th>Description Kh</th>
                      <th>Description En</th> */}
                      <th>Code</th>
                      <th>Category</th>
                      <th>Level</th>
                      {/* <th  className="w-250px">Created Date</th> */}
                      <th className="text-center w-150px">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                    this.state.questions && this.state.questions.map((question, index)=> {
                      return <tr>
                        <th scope="row">{( (this.state.page - 1) * this.state.limit) + (index+ 1)}</th>
                        {/* <td><img style={{width: 30, height: 30, borderRadius: 30}} src={video.thumbnail_url} alt="video thumbnail" /></td> */}
                        {/* <td>
                          <div class="media">
                            <img class="avatar" src={question.image_url ? question.image_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                            <div class="media-body">
                              <p >{video.title_kh}</p>
                            </div>
                          </div>
                        </td> */}
                        <td>
                          {/* {console.log(question.test_available)} */}
                          <input 
                            type="checkbox"
                            checked={question.test_available ? true : false }

                            // defaultChecked={question.test_available}
                            
                            onChange={(e) => {
                              e.preventDefault();
                              this.updateTestAvailable({
                                id: question.id,
                                test_available: e.target.checked? 1 : 0
                              })
                            }}
                          />
                        </td>
                        <td>{question.name}</td>
                        <td>{question.question}</td>
                        {/* <td>{video.description_kh}</td>
                        <td>{video.description_en}</td> */}
                        <td className="w-100px">{question.code}</td>
                        <td className="w-100px">{this.state.all_categories.map((category, index) => {
                          if(category.id === question.category_id) {
                            return category.name
                          }
                           
                        })}</td>
                        <td>{question.level}</td>
                        {/* <td className="w-250px">{moment(question.created_at).format("DD-MMM-YYYY")}</td> */}
                        <td className="text-right table-actions">
                          {/* <Link title="View" class="btn btn-square btn-round btn-primary" to={`/userview?id=${user.id}`}><i className="fa fa-eye"></i></Link> */}
                          <Link className="btn btn-square btn-round btn-primary" title="View" to={`/questionedit?id=${question.id}`}><i className="fa fa-eye"></i></Link>
                          <span>&nbsp;</span><Link className="btn btn-square btn-round btn-info" title="Edit" to={`/questionedit?id=${question.id}`}><i className="ti-pencil"></i></Link>
                        
                          <span>&nbsp;</span><Link title="Delete" onClick={() => this.setState({data: question})} className="btn btn-square btn-round btn-danger"><i className='ti-trash' data-toggle="modal" data-target="#modal-center" ></i> </Link>

                          {/* <div className="dropdown table-action">
                            <span className="dropdown-toggle no-caret hover-primary" data-toggle="dropdown" title="More"><i class="ti-more-alt rotate-90"></i></span>
                            <div className="dropdown-menu dropdown-menu-right">
                              <a className="dropdown-item" href="/"><i class="ti-menu-alt"></i> Details</a>
                              <a className="dropdown-item" href="/"><i class="ti-clip"></i> Add file</a>
                              <a className="dropdown-item" href="/"><i class="ti-bar-chart"></i> Performance</a>
                            </div>
                          </div> */}
                        </td>
                      </tr>
                      
                    })
                  }
                  </tbody>
                </table>
                <Pagination 
                onPaginationPress={this.onPaginationPress}
                totalPageLength = {this.state.total}
                limit = {this.state.limit}
                selectPage = {this.state.page}
              />

                <footer className="card-footer text-right">
                    {/* <Link className="btn btn-secondary" to="/categoryindex">Cancel</Link> */}
                    <button className="btn btn-secondary" onClick={this.goBack}>Back</button>
                    <button className="btn btn-primary" type="submit">Submit</button>
                </footer>
            </form>
            {
              this.state.data &&
              <CustomModal 
                data={ this.state.data } 
                title="Do you really want to delete this question?"
                deleteQuiz = {this.deleteQuiz} 
              />
           }
        </div>
    )
  }
}

// Functional wrapper to provide navigate
const MyComponentWithNavigate = () => {
  const navigate = useNavigate();
  return <CategoryEdit navigate={navigate} />;
};

export default MyComponentWithNavigate;